import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import TopTabbar from "../components/partials/TopTabbar";
import Header from "../components/partials/Header";
import Footer from "../components/partials/Footer";
import Step1Form from '../components/modals/transfert/formStep/Step1Form';
import Step2Form from '../components/modals/transfert/formStep/Step2Form';
import Step3Form from '../components/modals/transfert/formStep/Step3Form';
import Step4Form from '../components/modals/transfert/formStep/Step4Form';
import Step5Form from '../components/modals/transfert/formStep/Step5Form';
import AuthService from '../services/AuthService';
import UserService from '../services/UserService';
import LoadingSpinner from '../utils/LoadingSpinner';

const InitTransferPage = () => {
    const navigate = useNavigate();
    const currentUser = AuthService.getCurrentUser();
    const [isUserIdentified, setIsUserIdentified] = useState(null);
    const [currentStep, setCurrentStep] = useState(1);
    const [isPageLoading, setIsPageLoading] = useState(true);
    const [formData, setFormData] = useState({
        issuerBankName: '',
        country: '',
        withdrawalMethod: '',
        issuerName: currentUser ? `${currentUser.firstName} ${currentUser.lastName}` : '',
        issuerEmail: currentUser ? currentUser.email : '',
        userName: currentUser ? currentUser.username : '',
        transactionAmount: 0,
        transactionReceiverAmount: 0,
        walletAccountNumber: '',
        recipientWalletAccountInfo: null,
        recipientId: null,
        recipientBankAccountInfo: null
    });
    const [recipientInfo, setRecipientInfo] = useState(null);
    const [selectedAccount, setSelectedAccount] = useState(null);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevFormData => {
            const newValue = ['transactionAmount', 'recipientId', 'recipientBankAccountInfo', 'recipientWalletAccountInfo']
                .includes(name) ? Number(value) || null : value;
            return {
                ...prevFormData,
                [name]: newValue
            };
        });
    };

    const handleNextStep = (recipientInfo, account) => {
        if (recipientInfo) {
            setRecipientInfo(recipientInfo);
        }
        if (account) {
            setSelectedAccount(account);
        }
        setCurrentStep(currentStep + 1);
    };

    const handlePreviousStep = () => {
        setCurrentStep(currentStep - 1);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        ////console.log("Final form data:", formData);
        alert('Transfer submitted!');
    };

    // Vérification de l'identification de l'utilisateur
    useEffect(() => {
        const checkUserIdentification = async () => {
            try {
                const username = currentUser ? currentUser.username : null;
                const language = currentUser ? currentUser.language : 'fr';
                if (!username) {
                    throw new Error('Username not found');
                }
                const isIdentified = await UserService.checkIdentification(username, language);
                setIsUserIdentified(isIdentified);
                if (!isIdentified) {
                    const capitalizedFirstName = currentUser.firstName.charAt(0).toUpperCase() + currentUser.firstName.slice(1).toLowerCase();
                    Swal.fire({
                        icon: 'warning',
                        title: 'Identification requise',
                        html: `Bonjour <strong>${capitalizedFirstName}</strong>, vous ne pouvez pas encore effectuer de transferts. Vous devez d'abord soumettre votre identification. Nos équipes vous recontacteront dans les 30 min pour valider votre demande.`,
                        confirmButtonText: 'OK'
                    }).then(() => {
                        navigate('/identity');
                    });
                }
            } catch (error) {
                console.error('Error checking user identification:', error);
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Une erreur est survenue lors de la vérification de votre identification.',
                    confirmButtonText: 'OK'
                }).then(() => {
                    navigate('/identity');
                });
            } finally {
                setIsPageLoading(false);
            }
        };
        checkUserIdentification();
    }, [currentUser, navigate]);

    if (isPageLoading) {
        return <LoadingSpinner isVisible={true} loadingText="Chargement des données..." />;
    }

    return (
        <TransitionGroup>
            <CSSTransition
                key={isUserIdentified ? 'identified' : 'not-identified'}
                timeout={500}
                classNames="fade"
            >
                <>
                    <div className="d-flex flex-column vh-100">
                        <div className="flex-grow-1 overflow-y-scroll">
                            <div style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                maxWidth: '800px',
                                margin: '0 auto'
                            }}>
                                <div className="verify-number-main">
                                    <TopTabbar userName={currentUser ? currentUser.firstName : 'Utilisateur'} />
                                    <Header />
                                    <style>
                                        {`
                                            .step1-form {
                                                max-width: 600px;
                                                margin: 0 auto;
                                                padding: 20px;
                                            }
                                            .form-fields-container {
                                                display: flex;
                                                flex-direction: column;
                                                gap: 1.5rem;
                                            }
                                            .form-group {
                                                margin-bottom: 0;
                                            }
                                            .form-control {
                                                height: 48px;
                                                border: 1px solid #ced4da;
                                                border-radius: 8px;
                                                padding: 0.75rem 1rem;
                                                font-size: 1rem;
                                                background-color: white;
                                            }
                                            .form-control:focus {
                                                border-color: #0d6efd;
                                                box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
                                            }
                                            .form-control.is-invalid {
                                                border-color: #dc3545;
                                            }
                                            .form-control.is-valid {
                                                border-color: #198754;
                                            }
                                            .invalid-feedback {
                                                display: block;
                                                margin-top: 0.25rem;
                                                font-size: 0.875rem;
                                                color: #dc3545;
                                            }
                                            .form-actions {
                                                margin-top: 2rem;
                                                display: flex;
                                                justify-content: flex-end;
                                            }
                                            .btn-primary {
                                                padding: 0.75rem 1.5rem;
                                                font-size: 1rem;
                                                border-radius: 8px;
                                            }
                                            .country-selector {
                                                position: relative;
                                            }
                                            .country-selector select {
                                                width: 100%;
                                                padding-right: 40px;
                                                appearance: none;
                                            }
                                            .flag-container {
                                                position: absolute;
                                                right: 12px;
                                                top: 50%;
                                                transform: translateY(-50%);
                                                pointer-events: none;
                                            }
                                            .country-selector::after {
                                                content: '';
                                                position: absolute;
                                                right: 40px;
                                                top: 50%;
                                                transform: translateY(-50%);
                                                border-left: 5px solid transparent;
                                                border-right: 5px solid transparent;
                                                border-top: 5px solid #495057;
                                                pointer-events: none;
                                            }
                                            .bank-selector {
                                                position: relative;
                                            }
                                            .suggestions-list {
                                                position: absolute;
                                                top: 100%;
                                                left: 0;
                                                width: 100%;
                                                background-color: white;
                                                border: 1px solid #ccc;
                                                border-top: none;
                                                list-style: none;
                                                padding: 0;
                                                margin: 0;
                                                z-index: 10;
                                            }
                                            .suggestion-item {
                                                padding: 8px 12px;
                                                cursor: pointer;
                                            }
                                            .suggestion-item:hover {
                                                background-color: #f0f0f0;
                                            }
                                            .step5-form {
                                                max-width: 600px;
                                                margin: 0 auto;
                                                padding: 20px;
                                                border: 1px solid #ccc;
                                                border-radius: 8px;
                                                box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
                                            }
                                            .step5-form h2 {
                                                text-align: center;
                                                margin-bottom: 20px;
                                            }
                                            .summary-info {
                                                margin-bottom: 20px;
                                            }
                                            .summary-info p {
                                                margin: 10px 0;
                                            }
                                            .recipient-info, .account-info {
                                                margin-top: 20px;
                                                padding: 10px;
                                                border: 1px solid #ddd;
                                                border-radius: 8px;
                                                background-color: #f9f9f9;
                                            }
                                            .recipient-info p, .account-info p {
                                                margin: 10px 0;
                                            }
                                            .form-actions {
                                                display: flex;
                                                justify-content: space-between;
                                                margin-top: 20px;
                                            }
                                            .withdrawal-methods {
                                                display: flex;
                                                flex-direction: column;
                                                gap: 16px;
                                            }
                                            .transfer-first {
                                                height: 100px;
                                                border: 1px solid #ccc;
                                                border-radius: 8px;
                                                padding: 16px;
                                                cursor: pointer;
                                                transition: background-color 0.3s ease;
                                                display: flex;
                                                align-items: center;
                                            }
                                            .transfer-first.selected {
                                                border-color: #007bff;
                                                background-color: #f0f8ff;
                                            }
                                            .transfer-first .bank-img img {
                                                width: 64px;
                                                height: 64px;
                                                margin-right: 16px;
                                            }
                                            .transfer-first .bank-details h2 {
                                                font-size: 18px;
                                                margin-top: 8px;
                                            }
                                            .transfer-first .bank-active-sec {
                                                margin-left: auto;
                                                text-align: center;
                                            }
                                            .step3-form {
                                                padding: 20px;
                                                background-color: #f8f9fa;
                                                border-radius: 8px;
                                                box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
                                            }
                                            .search-input {
                                                border-radius: 20px;
                                                padding: 10px 15px;
                                                border: 1px solid #ced4da;
                                                transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
                                            }
                                            .search-input:focus {
                                                border-color: #80bdff;
                                                box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
                                            }
                                            .recipient-list {
                                                margin-top: 20px;
                                            }
                                            .recipient-item {
                                                padding: 15px;
                                                border: 1px solid #dee2e6;
                                                border-radius: 8px;
                                                margin-bottom: 10px;
                                                cursor: pointer;
                                                transition: background-color 0.15s ease-in-out;
                                            }
                                            .recipient-item:hover {
                                                background-color: #e9ecef;
                                            }
                                            .recipient-name {
                                                font-size: 18px;
                                                font-weight: bold;
                                            }
                                            .recipient-location {
                                                color: #6c757d;
                                                font-size: 14px;
                                            }
                                            .recipient-modal .modal-content {
                                                border-radius: 12px;
                                            }
                                            .recipient-modal .modal-header {
                                                border-bottom: none;
                                            }
                                            .recipient-modal .modal-footer {
                                                border-top: none;
                                                display: flex;
                                                justify-content: space-between;
                                            }
                                            .account-list {
                                                margin-top: 10px;
                                            }
                                            .account-item {
                                                margin-bottom: 10px;
                                            }
                                            .form-actions {
                                                margin-top: 20px;
                                                display: flex;
                                                justify-content: flex-end;
                                            }
                                        `}
                                    </style>
                                    <div className="verify-number-top">
                                        <div className="container">
                                            <div className="verify-number-top-content">
                                                <div className="header-title mt-32">
                                                    <p style={{ fontSize: '25px', fontWeight: 'bold' }}>Initialisation du transfert</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="verify-number-bottom" id="send-money-contact">
                                        <div className="verify-number-bottom-wrap">
                                            <div className="send-contact-favourite">
                                                <div className="favourite-list">
                                                    <div className="tab-content" id="nav-tabContent">
                                                        <div className="tab-pane show active" id="nav-all" role="tabpanel" tabIndex="0" aria-labelledby="nav-contact-tab">
                                                            <div className="nav-all-content">
                                                                {currentStep === 1 && (
                                                                    <Step1Form
                                                                        formData={formData}
                                                                        handleChange={handleChange}
                                                                        onNext={handleNextStep}
                                                                    />
                                                                )}
                                                                {currentStep === 2 && (
                                                                    <Step2Form
                                                                        formData={formData}
                                                                        handleChange={handleChange}
                                                                        onNext={handleNextStep}
                                                                        onBack={handlePreviousStep}
                                                                    />
                                                                )}
                                                                {currentStep === 3 && (
                                                                    <Step3Form
                                                                        formData={formData}
                                                                        handleChange={handleChange}
                                                                        onNext={handleNextStep}
                                                                        onBack={handlePreviousStep}
                                                                    />
                                                                )}
                                                                {currentStep === 4 && (
                                                                    <Step4Form
                                                                        formData={formData}
                                                                        handleChange={handleChange}
                                                                        onNext={handleNextStep}
                                                                        onBack={handlePreviousStep}
                                                                        recipientInfo={recipientInfo}
                                                                        selectedAccount={selectedAccount}
                                                                    />
                                                                )}
                                                                {currentStep === 5 && (
                                                                    <Step5Form
                                                                        formData={formData}
                                                                        recipientInfo={recipientInfo}
                                                                        selectedAccount={selectedAccount}
                                                                        onBack={handlePreviousStep}
                                                                        onSubmit={handleSubmit}
                                                                    />
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <Footer />
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            </CSSTransition>
        </TransitionGroup>
    );
};

export default InitTransferPage;
